<template>
  <div class="background">
    <Header />
    <slot /> <!-- This is where the content of `ahli.vue` will be injected -->
  </div>
</template>


<style scoped>
.background {
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
  align-items: center;
  background-attachment: fixed;
  background-image: url("@/assets/jkt/HomePage/background.png");
  background-position: center;
  background-size: cover;
  color: white;
  min-block-size: 100vh;
}

header {
  padding: 10px;
  inline-size: 100%;
}

.top-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-block: 10px;
  padding-inline: 20px;
}

.logo {
  block-size: 45px;
}

.nav-links {
  display: flex;
  gap: 20px;
  text-decoration: underline;
}

.nav-links a {
  color: white;
  font-size: 1rem;
  text-decoration: none;
}

.nav-links a:hover {
  text-decoration: underline;
}

@media (max-width: 768px) {
  .top-bar {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding-inline: 15px;
  }

  .logo {
    block-size: 40px;
  }

  .nav-links {
    display: none; /* Hide navigation links to save space on tablets */
  }

  /* Center align content inside the background */
  .background {
    background-size: cover;
    padding: 0 10px;
  }
}

/* Responsive styling for mobile devices (480px and below) */
@media (max-width: 480px) {
  .top-bar {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding-inline: 10px;
  }

  .logo {
    inline-size: 100px;
  }

  .nav-links {
    display: none; /* Hide navigation links on mobile for simplicity */
  }

  .background {
    padding: 0 5px;
    background-size: cover;
  }
}
</style>
